import { TravelStatsDashboard } from '@/components/gamification/TravelStatsDashboard';
import { TripErrorBoundary } from '@/utils/errorBoundary';

export default function TravelStatsDashboardRoute() {
  return (
    <TripErrorBoundary name="GamificationStats">
      <TravelStatsDashboard />
    </TripErrorBoundary>
  );
}
